import { XYChartToolbarSlotProps } from '../types/xy-chart-props.js';

export const Toolbar = (props: XYChartToolbarSlotProps) => null;

Toolbar['displayName'] = 'XYChartChart.Toolbar';
